export default __webpack_public_path__ + "static/media/bug.767c4a0b.svg";